// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".program-item__thumbnail-image{transition:transform .3s ease-in-out}.program-item:hover .program-item__thumbnail-image{transform:scale(1.1)}.program-item:hover .program-item__overlay{display:flex}", ""]);
// Exports
module.exports = exports;
